import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FormPostParent from '../../Components/FormPostParent';
import Post from '../../Components/Post';
import { selectIsLoading } from '../../Containers/App/selector';
import { selectProfile } from '../../Containers/Client/selector';
import { getPost } from '../../Containers/PostContainer/action';
import { selectPostData } from '../../Containers/PostContainer/selector';


import style from './style.module.scss';

function Timeline({posts, profile, isLoading}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPost('timeline'));
  },[]);

  return (
    <div className={style.parent}>
      <div>
        <div className={style.postForm}>
          <FormPostParent profilePicture={profile.profilePicture}/>
        </div>
        <div className={style.mainContainer}>
          {!isLoading && posts?.length>0?
          posts.map((post, key) => {
          return (
            <Post data={post} key={key} loggedInUser={profile.username}/>
          );
          })
          : (<div className={style.noPost}>Follow more people or create your first mark!</div>)}
        </div>

      </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  posts: selectPostData,
  profile: selectProfile,
  isLoading: selectIsLoading,
})

export default connect(mapStateToProps)(Timeline)